var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React, { Component } from "react";
import styled from "styled-components";
import { FormattedMessage, injectIntl } from "@irati/utils/lang";
import Button from "@irati/ui/src/Button";
import { ButtonLink } from "@irati/ui/src/Link";
import companyBenefitsService from "@irati/deals/services/companyBenefits";
import { getDomain } from "@irati/utils/links";
import authentication from "@irati/auth";
import { AreYouSurePopUp } from "../../AreYouSurePopUp";
var PreviewButton = styled(ButtonLink)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  margin-right: 15px;\n"], ["\n  margin-right: 15px;\n"])));
var EditButton = styled(ButtonLink)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  margin-right: 15px;\n"], ["\n  margin-right: 15px;\n"])));
var FlexWrapper = styled.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n"], ["\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n"])));
var CompanyBenefitsActions = /** @class */ (function (_super) {
    __extends(CompanyBenefitsActions, _super);
    function CompanyBenefitsActions() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.deletePopup = React.createRef();
        _this.state = {
            load: null
        };
        _this.buildUrl = function () {
            var benefit = _this.props.benefit;
            return getDomain(authentication.userTenant().subdomain) + "/perks/info/" + benefit.urlSlug;
        };
        _this.handleArchive = function () {
            var benefit = _this.props.benefit;
            var load = companyBenefitsService.archive(benefit.uuid).then(function () { return _this.props.onChange(benefit, "remove"); });
            _this.setState({ load: load });
            return load;
        };
        _this.openArchivePopup = function () {
            if (_this.deletePopup.current) {
                _this.deletePopup.current.toggle();
            }
        };
        _this.handleEdit = function () {
            _this.props.onBenefitEdit(_this.props.benefit);
        };
        return _this;
    }
    CompanyBenefitsActions.prototype.render = function () {
        var load = this.state.load;
        var formatMessage = this.props.formatMessage;
        return (React.createElement(FlexWrapper, null,
            React.createElement(PreviewButton, { href: this.buildUrl(), target: "_blank", small: true },
                React.createElement(FormattedMessage, { id: "admin.components.companyBenefitsActions.previewButton.text" })),
            React.createElement(EditButton, { onClick: this.handleEdit, small: true },
                React.createElement(FormattedMessage, { id: "admin.components.companyBenefitsActions.editButton.text" })),
            React.createElement(Button, { onClick: this.openArchivePopup, load: load, small: true },
                React.createElement(FormattedMessage, { id: "admin.components.companyBenefitsActions.archiveButton.text" })),
            React.createElement(AreYouSurePopUp, { ref: this.deletePopup, load: load, onSubmit: this.handleArchive, text: formatMessage({ id: "admin.components.companyBenefitsActions.areYouSurePopUp.text" }), buttonText: formatMessage({ id: "admin.components.companyBenefitsActions.areYouSurePopUp.buttonText" }) })));
    };
    return CompanyBenefitsActions;
}(Component));
export default injectIntl(CompanyBenefitsActions);
var templateObject_1, templateObject_2, templateObject_3;
